import { Injectable, Input } from '@angular/core';
import { DataService } from '@app/core/services/data.service';
import { SignupService } from '../services/signup.service';
import { validationMsgs } from '@app/core/constants/validationMsgs';
import { regEx } from '@app/core/constants/regEx';

@Injectable({
    providedIn: 'root'
})
export class NextOfKinService {

    @Input() slideNumber: string | undefined;

    constructor(
        private signupService: SignupService,
        private dataService: DataService
    ) { }

    //schema and form are now combined...
    fetchSchema(referenceTypes: any): any {
        const yesNoMap = [
            {
                "value": false,
                "name": "No"
            },
            {
                "value": true,
                "name": "Yes"
            }
        ];

        return [
            {
                wrappers: [ 'section' ],
                props: { htmlClass: '' },
                fieldGroup: [
                    {
                        wrappers: [ 'connectSection' ],
                        props: { htmlClass: 'section' },
                        fieldGroup: [
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: '' },
                                fieldGroup: [
                                    {
                                        wrappers: [ 'section' ],
                                        props: { htmlClass: 'row' },
                                        fieldGroup: [
                                            {
                                                wrappers: [ 'section' ],
                                                props: { htmlClass: 'col-sm-6' },
                                                fieldGroup: [
                                                    {
                                                        key: 'title',
                                                        type: 'select',
                                                        props: {
                                                            title: 'Title',
                                                            required: true,
                                                            options: this.dataService.getReferenceDataByName(referenceTypes, 'cn_titletype')
                                                        }
                                                    }
                                                ]
                                            },
                                            {
                                                wrappers: [ 'section' ],
                                                props: { htmlClass: 'col-sm-6' },
                                                fieldGroup: [
                                                    {
                                                        key: "firstName",
                                                        type: "input",
                                                        props: {
                                                            title: "First Name",
                                                            required: true,
                                                            minLength: 0,
                                                            maxLength: 35,
                                                            pattern: regEx.namePattern
                                                        },
                                                        validation: {
                                                            messages: {
                                                                pattern: validationMsgs.alphaOnly,
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        wrappers: [ 'section' ],
                                        props: { htmlClass: 'row' },
                                        fieldGroup: [
                                            {
                                                wrappers: [ 'section' ],
                                                props: { htmlClass: 'col-sm-6' },
                                                fieldGroup: [
                                                    {
                                                        key: "lastName",
                                                        type: "input",
                                                        props: {
                                                            title: "Last Name",
                                                            required: true,
                                                            maxLength: 35,
                                                            pattern: regEx.namePattern
                                                        },
                                                        validation: {
                                                            messages: {
                                                                pattern: validationMsgs.alphaOnly,
                                                            }
                                                        }
                                                    }
                                                ]
                                            },
                                            {
                                                wrappers: [ 'section' ],
                                                props: { htmlClass: 'col-sm-6' },
                                                fieldGroup: [
                                                    {
                                                        key: 'nextOfKinRelationship',
                                                        type: 'select',
                                                        props: {
                                                            title: 'Relationship to Applicant',
                                                            required: true,
                                                            options: this.dataService.getReferenceDataByName(referenceTypes, 'cn_nextofkinrelationshiptype')
                                                        }
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        wrappers: [ 'connectSection' ],
                        props: { htmlClass: 'section', title: 'Contact Details' },
                        fieldGroup: [
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'row' },
                                fieldGroup: [
                                    {
                                        wrappers: [ 'section' ],
                                        props: { htmlClass: 'col-sm-6' },
                                        fieldGroup: [
                                            {
                                                key: 'houseNumberName',
                                                type: 'input',
                                                props: {
                                                    title: 'House name or number',
                                                    required: true,
                                                    maxLength: 40,
                                                    pattern: regEx.alphaNumericPattern,
                                                },
                                                validation: {
                                                    messages: {
                                                        pattern: validationMsgs.alphaNumeric
                                                    }
                                                }
                                            },
                                            {
                                                key: 'street',
                                                type: 'input',
                                                props: {
                                                    title: 'Street',
                                                    maxLength: 40,
                                                    pattern: regEx.addressPattern,
                                                },
                                                validation: {
                                                    messages: {
                                                        pattern: validationMsgs.alphaNumericOptional
                                                    }
                                                }
                                            },
                                            {
                                                key: 'addressLine3',
                                                type: 'input',
                                                props: {
                                                    title: 'Address Line 3',
                                                    maxLength: 40,
                                                    pattern: regEx.addressPattern,
                                                },
                                                validation: {
                                                    messages: {
                                                        pattern: validationMsgs.alphaNumericOptional
                                                    }
                                                }
                                            },
                                            {
                                                key: 'city',
                                                type: 'input',
                                                props: {
                                                    title: 'City',
                                                    maxLength: 40,
                                                    pattern: regEx.alphaPattern,
                                                },
                                                validation: {
                                                    messages: {
                                                        pattern: validationMsgs.alphaOnlyOptional
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        wrappers: [ 'section' ],
                                        props: { htmlClass: 'col-sm-6' },
                                        fieldGroup: [
                                            {
                                                key: 'county',
                                                type: 'input',
                                                props: {
                                                    title: 'County',
                                                    maxLength: 40,
                                                    pattern: regEx.alphaPattern,
                                                },
                                                validation: {
                                                    messages: {
                                                        pattern: validationMsgs.alphaOnlyOptional
                                                    }
                                                }
                                            },
                                            {
                                                key: 'country',
                                                type: 'input',
                                                props: {
                                                    title: 'Country',
                                                    maxLength: 80,
                                                    pattern: regEx.countryPattern,
                                                },
                                                validation: {
                                                    messages: {
                                                        pattern: validationMsgs.alphaOnlyOptional
                                                    }
                                                }
                                            },
                                            {
                                                key: 'postCode',
                                                type: 'input',
                                                props: {
                                                    title: 'Postcode',
                                                    maxLength: 8,
                                                    pattern: regEx.postCodePattern,
                                                    required: true
                                                },
                                                validation: {
                                                    messages: {
                                                        pattern: validationMsgs.postcode
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'row' },
                                fieldGroup: [
                                    {
                                        wrappers: [ 'section' ],
                                        props: { htmlClass: 'col-sm-6' },
                                        fieldGroup: [
                                            {
                                                key: 'mobilephoneNumber',
                                                type: 'input',
                                                props: {
                                                    title: 'Mobile phone number',
                                                    required: true,
                                                    maxLength: 15,
                                                    pattern: regEx.phonePattern,
                                                },
                                                validation: {
                                                    messages: {
                                                        pattern: validationMsgs.phone
                                                    }
                                                }
                                            },
                                            {
                                                key: 'otherPhoneNumber',
                                                type: 'input',
                                                props: {
                                                    title: 'Other phone number',
                                                    maxLength: 15,
                                                    pattern: regEx.phonePattern,
                                                },
                                                validation: {
                                                    messages: {
                                                        pattern: validationMsgs.phone
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        wrappers: [ 'section' ],
                                        props: { htmlClass: 'col-sm-6' },
                                        fieldGroup: [
                                            {
                                                key: 'emailAddress',
                                                type: 'input',
                                                props: {
                                                    title: 'Email address',
                                                    maxLength: 1000,
                                                    pattern: regEx.emailPattern,
                                                },
                                                validation: {
                                                    messages: {
                                                        pattern: validationMsgs.email
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        wrappers: [ 'connectSection' ],
                        props: { htmlClass: 'section' },
                        fieldGroup: [
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: '' },
                                fieldGroup: [
                                    {
                                        wrappers: [ 'section' ],
                                        props: { htmlClass: 'row' },
                                        fieldGroup: [
                                            {
                                                wrappers: [ 'section' ],
                                                props: { htmlClass: 'col-sm-12' },
                                                fieldGroup: [
                                                    {
                                                        key: "emergencyContact",
                                                        type: "radiobuttons",
                                                        props: {
                                                            labelHtmlClass: "control-label",
                                                            activeClass: "active",
                                                            required: true,
                                                            title: "Is the above person your emergency contact?",
                                                            options: yesNoMap
                                                        }
                                                    }
                                                ]
                                            },
                                            {
                                                wrappers: [ 'section' ],
                                                props: { htmlClass: 'col-sm-12' },
                                                fieldGroup: [
                                                    {
                                                        key: "permissionToSpeakAboutProperty",
                                                        type: "radiobuttons",
                                                        props: {
                                                            labelHtmlClass: "control-label",
                                                            activeClass: "active",
                                                            required: true,
                                                            title: "Do you give us permission to talk to them about your tenancy?",
                                                            options: yesNoMap
                                                        }
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }
}
